<template>
  <div id="consulting-topic-picture">
    <div class="image-container" v-if="!uploading">
      <v-img
        :aspect-ratio="4 / 4"
        :lazy-src="require('@/assets/NoPicture.png')"
        :src="downloadURL ? downloadURL : require('@/assets/NoPicture.png')"
        class="image grey lighten-2"
        cover
      >
        <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
          <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
        </v-layout>
      </v-img>
      <div @click="selectFile" class="overlay primary">
        <v-icon color="white" small>add_a_photo</v-icon>
      </div>
    </div>
    <input
      :multiple="false"
      @change="detectFiles($event)"
      accept="image/*"
      id="files"
      name="file"
      ref="uploadInput"
      style="display:none"
      type="file"
    />
    <v-progress-circular
      :rotate="360"
      :size="100"
      :value="progressUpload"
      :width="15"
      class="ma-2"
      color="primary"
      v-if="uploading && !uploadEnd"
      >{{ progressUpload }}%</v-progress-circular
    >
    <!-- <div v-if="uploadEnd">
      <v-btn @click="deleteImage()" class="ma-0" color="error" dark small>Delete</v-btn>
    </div>-->
  </div>
</template>

<script>
import firestorage from 'firebase/app' // Storage
export default {
  name: 'consulting-topic-picture',
  props: {
    idx: {
      type: String,
      default: ''
    },
    condition: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      uploading: false,
      uploadEnd: false
    }
  },
  watch: {
    uploadTask() {
      this.uploadTask.on(
        'state_changed',
        sp => {
          this.progressUpload = Math.floor((sp.bytesTransferred / sp.totalBytes) * 100)
        },
        null,
        () => {
          // upload finish
          this.uploadTask.snapshot.ref.getDownloadURL().then(async downloadURL => {
            this.uploading = false
            this.uploadEnd = true
            this.downloadURL = downloadURL
            // update into backend
            const data = {
              downloadURL: downloadURL,
              idx: this.idx,
              condition: this.condition,
              createdBy: localStorage.getItem('tokenAdmin')
            }
            this.$store.dispatch('ConsultingTopic/updatePicture', data)
            // reset file input
            const input = this.$refs.uploadInput
            input.type = 'text'
            input.type = 'file'
          })
        }
      )
    }
  },
  computed: {
    downloadURL: {
      // getter
      get() {
        return this.$store.getters['ConsultingTopic/getAll']
          .filter(item => item.idx == this.$store.state.ConsultingTopic.idx)
          .map(item => item.pictureIcon)[0]
      },
      // setter
      set() {}
    }
  },
  methods: {
    selectFile() {
      this.$refs.uploadInput.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload(file) {
      // Upload images to firebase and get URL
      var storageRef = firestorage.storage().ref()

      this.fileName = file.name
      var ext = file.name.slice(file.name.lastIndexOf('.'))
      // Create the file metadata
      var metadata = {
        contentType: 'image/jpeg'
      }
      this.uploading = true
      this.uploadEnd = false
      this.uploadTask = storageRef
        .child(`images/consulting_topic/` + window.btoa(this.idx) + 'icon' + ext)
        .put(file, metadata)
    },
    deleteImage() {
      // var pictureRef = firestorage.storage().refFromURL(formData.picture)
      // // Delete in Firebase
      // pictureRef.delete().then(() => {
      //   // File deleted successfully
      // })
      firestorage
        .ref('images/' + this.fileName)
        .delete()
        .then(() => {
          this.uploading = false
          this.uploadEnd = false
          this.downloadURL = ''
        })
        .catch(error => {
          throw new Error(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  margin: 10px 0;
}
.image-container {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 6px;
  width: 30px;
  transition: 0.5s ease;
  opacity: 1;
  text-align: center;
  padding: 0px 0px 4px 0px;
  margin: 10px;
}
.image-container:hover .overlay {
  opacity: 1;
}
</style>
